import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <nav className="privacy-nav">
        <Link to="/" className="nav-logo">Three Plates</Link>
        <div className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </div>
      </nav>

      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: January 2026</p>

        <section>
          <h2>Introduction</h2>
          <p>Three Plates ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application and website.</p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <h3>Account Information</h3>
          <p>When you create an account, we collect:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Password (encrypted)</li>
          </ul>

          <h3>Workout Data</h3>
          <p>When you use our app, we collect:</p>
          <ul>
            <li>Workout logs and exercise data</li>
            <li>Personal records and statistics</li>
            <li>Team membership information</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain our service</li>
            <li>Allow coaches to assign workouts to athletes</li>
            <li>Track your workout progress and statistics</li>
            <li>Send important updates about your account</li>
          </ul>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>We implement industry-standard security measures to protect your data, including encryption of sensitive information and secure server infrastructure.</p>
        </section>

        <section>
          <h2>Data Sharing</h2>
          <p>We do not sell your personal information. Your workout data is only shared with:</p>
          <ul>
            <li>Coaches on your team (if you are an athlete)</li>
            <li>Service providers necessary to operate our platform</li>
          </ul>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request deletion of your account</li>
            <li>Update your information</li>
          </ul>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact us at:</p>
          <p><strong>Email:</strong> threeplatesinfo@gmail.com</p>
        </section>
      </div>

      <footer className="privacy-footer">
        <p>&copy; 2026 Three Plates. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Privacy;
